import * as Apis from "../common/ApiUrls";
import httpService from "../common/HttpService";
import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    isConfigLoading: false,
    dictionary: {}
};

export default function configReducer(state = initialState, action) {
    var newState = { ...state };

    switch (action.type) {

        case Constants.REQUEST_COMPONENT_CONFIGURATION:
            newState.dictionary = {
                ...newState.dictionary,
                [action.configTypeId]: { isLoading: true, isLoaded: false, data: null }
            };
            return newState;

        case Constants.RECEIVE_COMPONENT_CONFIGURATION:
            newState.dictionary = {
                ...newState.dictionary,
                [action.configTypeId]: { isLoading: false, isLoaded: true, data: action.payload }
            };

            return newState;

        case Constants.FAILED_COMPONENT_CONFIGURATION:
            newState.dictionary = {
                ...newState.dictionary,
                [action.configTypeId]: { isLoading: false, isLoaded: true, data: null }
            };
            return newState;

        case Constants.RESET_COMPONENT_CONFIGURATION:
            newState.dictionary = {};
            return newState;

        default: return state;
    }
}

export const actionCreators = {

    requestComponentConfiguration: (configTypeId) => async (dispatch, getState) => {

        dispatch({ type: Constants.REQUEST_COMPONENT_CONFIGURATION, configTypeId });

        try {
            const response = await httpService.getAsync(`${Apis.CONFIGURATION}/${configTypeId}`, null, true);

            dispatch({
                configTypeId,
                type: Constants.RECEIVE_COMPONENT_CONFIGURATION,
                payload: response.data
            });

        } catch (e) {
            dispatch({ type: Constants.FAILED_COMPONENT_CONFIGURATION, configTypeId, error: e });
        }

    },

    resetComponentConfiguration: () => { return { type: Constants.RESET_COMPONENT_CONFIGURATION } }
};


// WEBPACK FOOTER //
// ./src/reducers/ConfigurationReducer.js